import { RouterModule, Routes } from '@angular/router'
import { NgModule } from '@angular/core'

import { AuthGuard } from '../../../services/guarad/auth.guard'
import { PendingChangesGuard } from '../../../services/guarad/pending-changes.guard'
import { TimelineComponent } from './timeline/timeline.component'
import { LayoutAppElementDetailComponent } from '../layout-app-element-detail/layout-app-element-detail.component'
import { AvailabilityGuard } from '../../../services/guarad/availability.guard'

const routes: Routes = [
    {
        path: 'app/main/communication/room',
        canActivate: [AuthGuard, AvailabilityGuard],
        component: LayoutAppElementDetailComponent,
        children: [
            // {path: '', redirectTo: ':id/home', pathMatch: 'full', canDeactivate: [PendingChangesGuard]},
            { path: ':id/home', component: TimelineComponent, canDeactivate: [PendingChangesGuard] },
        ],
    },
]

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})

export class CommunicationRoomRoutingModule {

}



// WEBPACK FOOTER //
// ./src/app/app_manager/app_element/communication-room/communication-room.routing.ts